var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fee903",
    d: "M474.971 351.681C484.692 325.29 490 296.765 490 267c0-135.31-109.69-245-245-245a246.356 246.356 0 0 0-45.18 4.157c-5.628 1.049-1.676 16.948-7.161 18.375-18.302 4.761-45.285-3.073-61.66 5.551C53.107 91.103 0 172.85 0 267c0 25.011 3.748 49.146 10.712 71.875.248.808 7.834 9.379 9.096 12.806z",
    opacity: 1,
    "data-original": "#fee903",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fac600",
    d: "M10.712 338.875C41.426 439.112 134.701 512 245 512s203.574-72.888 234.288-173.125z",
    opacity: 1,
    "data-original": "#fac600",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a65cb",
    d: "M131.915 75.319V308.17c0 6.475-5.249 11.723-11.723 11.723H55.638c-6.428 0-11.638-5.211-11.638-11.638V75.319c0-17.673 14.327-32 32-32h23.915c17.673 0 32 14.327 32 32z",
    opacity: 1,
    "data-original": "#2740b0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a65cb",
    d: "M512 75.319V308.17c0 6.475-5.249 11.723-11.723 11.723H93.915c-6.428 0-11.638-5.211-11.638-11.638V59.319c0-8.837 7.163-16 16-16H480c17.673 0 32 14.327 32 32z",
    opacity: 1,
    "data-original": "#314dc9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d58ba",
    d: "M482 81.319v276a8 8 0 0 1-8 8H82a8 8 0 0 1-8-8v-276a8 8 0 0 1 8-8h392a8 8 0 0 1 8 8z",
    opacity: 1,
    "data-original": "#0172fb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c5d3dd",
    d: "M334 373.319v64a8 8 0 0 1-8 8h-96a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8h96a8 8 0 0 1 8 8z",
    opacity: 1,
    "data-original": "#c5d3dd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5eef9",
    d: "M230 443.319v14a8 8 0 0 1-8 8h-32a8 8 0 0 1-8-8v-14a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8z",
    opacity: 1,
    "data-original": "#e5eef9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2fbff",
    d: "M374 443.319v14a8 8 0 0 1-8 8H218a8 8 0 0 1-8-8v-14a8 8 0 0 1 8-8h148a8 8 0 0 1 8 8z",
    opacity: 1,
    "data-original": "#f2fbff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01c0fa",
    d: "M512 307.75H44v27.569l1.596 1.447h464.34l2.064-1.447z",
    opacity: 1,
    "data-original": "#01c0fa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8e8f0",
    d: "M78.275 363.319v-21.787L72 335.319H44v28c0 17.673 14.327 32 32 32h34.275c-17.674 0-32-14.326-32-32z",
    opacity: 1,
    "data-original": "#d8e8f0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5eef9",
    d: "M512 335.319v28c0 17.673-14.327 32-32 32H104c-17.673 0-32-14.327-32-32v-28z",
    opacity: 1,
    "data-original": "#e5eef9",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#c5d3dd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 431.122,
    cy: 365.532,
    r: 10,
    fill: "#c5d3dd",
    opacity: 1,
    "data-original": "#c5d3dd",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.122,
    cy: 365.532,
    r: 10,
    fill: "#c5d3dd",
    opacity: 1,
    "data-original": "#c5d3dd",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.586 27.103h-37.172c-7.199 0-13.034-5.836-13.034-13.034v-1.035C99.379 5.836 105.215 0 112.414 0h37.172c7.199 0 13.034 5.836 13.034 13.034v1.035c.001 7.199-5.835 13.034-13.034 13.034zM149.586 262h-37.172c-7.199 0-13.034-5.836-13.034-13.034v-1.035c0-7.199 5.836-13.034 13.034-13.034h37.172c7.199 0 13.034 5.836 13.034 13.034v1.035c.001 7.198-5.835 13.034-13.034 13.034zM27.103 112.414v37.172c0 7.199-5.836 13.034-13.034 13.034h-1.035C5.836 162.621 0 156.785 0 149.586v-37.172c0-7.199 5.836-13.034 13.034-13.034h1.035c7.199-.001 13.034 5.835 13.034 13.034zM262 112.414v37.172c0 7.199-5.836 13.034-13.034 13.034h-1.035c-7.199 0-13.034-5.836-13.034-13.034v-37.172c0-7.199 5.836-13.034 13.034-13.034h1.035c7.198-.001 13.034 5.835 13.034 13.034zM70.676 44.392 44.392 70.676c-5.09 5.09-13.343 5.09-18.434 0l-.732-.732c-5.09-5.09-5.09-13.343 0-18.434l26.285-26.285c5.09-5.09 13.343-5.09 18.434 0l.732.732c5.09 5.091 5.09 13.344-.001 18.435zM236.773 210.489l-26.285 26.285c-5.09 5.09-13.343 5.09-18.434 0l-.732-.732c-5.09-5.09-5.09-13.343 0-18.434l26.285-26.285c5.09-5.09 13.343-5.09 18.434 0l.732.732c5.091 5.09 5.091 13.343 0 18.434zM44.392 191.324l26.285 26.285c5.09 5.09 5.09 13.343 0 18.434l-.732.732c-5.09 5.09-13.343 5.09-18.434 0L25.226 210.49c-5.09-5.09-5.09-13.343 0-18.434l.732-.732c5.09-5.091 13.343-5.091 18.434 0zM210.489 25.227l26.285 26.285c5.09 5.09 5.09 13.343 0 18.434l-.732.732c-5.09 5.09-13.343 5.09-18.434 0l-26.285-26.285c-5.09-5.09-5.09-13.343 0-18.434l.732-.732c5.09-5.091 13.343-5.091 18.434 0z",
    fill: "#c5d3dd",
    opacity: 1,
    "data-original": "#c5d3dd",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e5eef9",
    d: "M244.834 131.001c0 21.745-6.098 42.066-16.676 59.347a18.737 18.737 0 0 1-6.19 6.19c-17.281 10.578-37.602 16.676-59.347 16.676-62.66.001-113.836-51.175-113.835-113.835 0-21.736 6.093-42.05 16.663-59.326a18.81 18.81 0 0 1 6.224-6.224c17.276-10.57 37.589-16.663 59.326-16.663 62.66-.001 113.836 51.175 113.835 113.835z",
    opacity: 1,
    "data-original": "#e5eef9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d8e8f0",
    d: "M229.225 188.569c-19.774 33.665-56.36 56.265-98.225 56.265-62.869 0-113.834-50.965-113.834-113.834 0-41.865 22.6-78.451 56.265-98.225-9.921 16.89-15.61 36.565-15.61 57.569 0 62.869 50.965 113.834 113.834 113.834 21.004.001 40.679-5.688 57.57-15.609z",
    opacity: 1,
    "data-original": "#d8e8f0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5955b6",
    d: "M219.373 131.001c0 16.882-4.734 32.657-12.946 46.073a14.54 14.54 0 0 1-4.805 4.805c-13.415 8.212-29.191 12.946-46.073 12.946-48.645 0-88.374-39.729-88.374-88.374 0-16.875 4.73-32.644 12.936-46.056a14.609 14.609 0 0 1 4.832-4.832c13.412-8.206 29.182-12.936 46.056-12.936 48.645 0 88.374 39.729 88.374 88.374z",
    opacity: 1,
    "data-original": "#4f66d0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a65cb",
    d: "M207.255 175.693c-15.351 26.135-43.754 43.68-76.255 43.68-48.807 0-88.373-39.566-88.373-88.373 0-32.501 17.545-60.904 43.68-76.255-7.702 13.112-12.118 28.387-12.118 44.693 0 48.807 39.566 88.373 88.373 88.373 16.306 0 31.58-4.416 44.693-12.118z",
    opacity: 1,
    "data-original": "#314dc9",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01c0fa",
    d: "M310 155h120c11.046 0 20-8.954 20-20s-8.954-20-20-20H310c-11.046 0-20 8.954-20 20s8.954 20 20 20z",
    opacity: 1,
    "data-original": "#01c0fa",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.667,
    cy: 135,
    r: 10,
    fill: "#99e6fc",
    opacity: 1,
    "data-original": "#99e6fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.333,
    cy: 135,
    r: 10,
    fill: "#99e6fc",
    opacity: 1,
    "data-original": "#99e6fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 135,
    r: 10,
    fill: "#62dbfb",
    opacity: 1,
    "data-original": "#62dbfb",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 135,
    r: 10,
    fill: "#dcf5f8",
    opacity: 1,
    "data-original": "#dcf5f8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01c0fa",
    d: "M310 220h120c11.046 0 20-8.954 20-20s-8.954-20-20-20H310c-11.046 0-20 8.954-20 20s8.954 20 20 20z",
    opacity: 1,
    "data-original": "#01c0fa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0ed2b3",
    d: "M325 275h30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15h-30c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15z",
    opacity: 1,
    "data-original": "#0ed2b3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5dd39e",
    d: "M354.213 275H415c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15h-60.787c-8.284 0-15 6.716-15 15 0 8.284 6.715 15 15 15z",
    opacity: 1,
    "data-original": "#05e39c",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386.667,
    cy: 200,
    r: 10,
    fill: "#dcf5f8",
    opacity: 1,
    "data-original": "#dcf5f8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.333,
    cy: 200,
    r: 10,
    fill: "#99e6fc",
    opacity: 1,
    "data-original": "#99e6fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 200,
    r: 10,
    fill: "#62dbfb",
    opacity: 1,
    "data-original": "#62dbfb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5c2",
    d: "M129.994 126.916h2.013c14.007 0 25.362-11.355 25.362-25.362V90.752c0-14.007-11.355-25.362-25.362-25.362h-2.013c-14.007 0-25.362 11.355-25.362 25.362v10.802c0 14.007 11.355 25.362 25.362 25.362z",
    opacity: 1,
    "data-original": "#ffe5c2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5dd39e",
    d: "M91.507 191.434h78.986a5 5 0 0 0 5-5v-17.737c0-16.569-13.431-30-30-30h-28.986c-16.569 0-30 13.431-30 30v17.737a5 5 0 0 0 5 5z",
    opacity: 1,
    "data-original": "#05e39c",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.d2d61ebfe1e1727fdcbc6e7ff4a8d16d.svg";
export { ForwardRef as ReactComponent };